import { Component,OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { TYPEMODULE, LoaderService, NotificationService, CONSTANT, GridDataSource } from '../../../../shared/session/index';
import { RolService } from '../../Roles/shared/rol.service';
import { PageEvent, MatPaginator } from '@angular/material';

@Component({
  selector: 'app-aplicacion-rol-list',
  // styleUrls: ['table-basic-example.css'],
  templateUrl: 'aplicacion-rol-list.component.html',
})

export class AplicacionRolListComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
	@Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() typeModule: TYPEMODULE;
  @Input() titlePage: string;
  @Input() data: any;

  pageSize: number;
  pageEvent: PageEvent;
  displayedColumns: string[] ;
  dataSource: GridDataSource;
  msgErrorGet: string;
  selectedRowIndex: number = -1;
  showMessageGridEmpty: boolean = false;
  pageSizeOptions: number[] = CONSTANT.pageSizeOptions;

  constructor(
    private loaderService: LoaderService,
    private rolService: RolService,
    private notificationService: NotificationService
  ) { }

  ngOnInit() {
    this.pageSize = 0; //CONSTANT.pageSize;
    this.pageEvent = new PageEvent();
    this.clearMatPaginator();
    this.msgErrorGet = 'Error al listar los roles';
    this.displayedColumns = ['RoleID','Name','Descripcion','Status'];
  }

  searchEmit(data: any) {
		this.buscarRol(this.data.aplicacion.ID, data.filtro);
  }

  changeEvent(event) {
    this.onChangeEvent.emit(event);
  }

	buscarRol(AplicacionID: number, filtro: string){
    this.clearMatPaginator();
    this.listarRolAplicacion(AplicacionID, filtro);
  }

  private clearMatPaginator() {
    this.pageEvent.pageIndex = 0;
    this.pageEvent.pageSize = this.pageSize;
    this.pageEvent.length = 0;
  }

  private setMatPaginator() {
    this.paginator.length = this.pageEvent.length;
    this.paginator.pageIndex = this.pageEvent.pageIndex;
    this.paginator.pageSize = this.pageEvent.pageSize;
  }

  private listarRolAplicacion(AplicacionID:number, filtro: string){
    this.loaderService.show();
    this.rolService.listarRolPorAplicacion(AplicacionID,filtro, this.pageEvent.pageIndex, this.pageEvent.pageSize)
    .subscribe(res => {
			// if (this.errorService.getMessageError(res)) {
        this.dataSource = new GridDataSource(res);
        this.showHideMessageGridEmpty(Number(res.length));
        this.pageEvent.length = res.length;
        this.setMatPaginator();
			// }
		},
		error => {
			this.notificationService.error(this.msgErrorGet);
			throw error;
		},
		() => {
			this.loaderService.hide();
		});
  }

  public showHideMessageGridEmpty(rows: number) {
    this.showMessageGridEmpty = false;
    if (rows <= 0) this.showMessageGridEmpty = true;
  }
}

